export default __webpack_public_path__ + "static/media/downloadIcon.1f2a5768.svg";